import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ButtonText from "../../common/ButtonText";
import CustomTextField from "../../common/TextField";

const useStyles = makeStyles(theme => ({
  colSearchIcon: {
    fontSize: 11,
    color: "#ccc",
  },
  colSearch: {
    fontWeight: 400,
    "& .MuiInputBase-input": {
      paddingTop: 7,
      paddingBottom: 7,
    },
    maxWidth: "fit-content",
    display: "flex",
    flexDirection: "column",
  },
  btnColClear: {
    color: theme.palette.primary.main,
    fontSize: 10,
    marginTop: 5,
    marginRight: 8,
  },
  btnColSearch: {
    padding: "5px 15px",
    fontWeight: 600,
    color: theme.palette.common.white,
    fontSize: 9,
    backgroundColor: theme.palette.primary.light,
    minWidth: "unset",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: theme.palette.common.neon,
    },
    width: "auto",
    marginTop: 5,
  },
}));

const ColumnSearch = ({
  name,
  value,
  onClear,
  onChange,
  onSearch,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  const numberType =
    name === "VersionNo" || name === "Size" ? "number" : "text";

  return (
    <Box className={classes.colSearch} align="right">
      <CustomTextField
        placeholder={intl.formatMessage({
          id: "btn.search",
        })}
        name={name}
        onChange={onChange}
        value={value}
        type={numberType}
      />
      <Box>
        <ButtonText
          onClick={onClear}
          label={<FormattedMessage id="pickingList.clear" />}
          btnClass={classes.btnColClear}
        />
        <Button
          className={classes.btnColSearch}
          onClick={onSearch}
        >
          <FormattedMessage id="btn.search" />
        </Button>
      </Box>
    </Box>
  );
};

ColumnSearch.defaultProps = {
  name: null,
  value: null,
};

ColumnSearch.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default ColumnSearch;
